import { render, staticRenderFns } from "./LayoutBreadcrumb.vue?vue&type=template&id=552aac83&"
import script from "./LayoutBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./LayoutBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBreadcrumb.vue?vue&type=style&index=0&id=552aac83&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBreadcrumbs from 'quasar/src/components/breadcrumbs/QBreadcrumbs.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QTooltip,QIcon,QBreadcrumbs});
